import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router-dom';

import Paywall from 'shared/components/Paywall';
import { user } from 'shared/redux/selectors';
import { PaywallContext } from 'shared/utils/protectedResources';
import { toAbsoluteUrl } from 'shared/utils/urls';

const ReductionPaywall = () => {
  const history = useHistory();
  const {
    params: { betId },
  } = useRouteMatch();
  const isSubscriber = useSelector(user.hasSubscription);
  const returnPath = `/trav/${betId}`;
  const [contextValue] = useState({
    cancelPaywall: () => history.push(returnPath),
  });

  useEffect(() => {
    // In case a subscriber lands on this path, navigate away
    if (isSubscriber) {
      history.replace(returnPath);
    }
  }, [history, isSubscriber, returnPath]);

  return (
    <PaywallContext.Provider value={contextValue}>
      <Paywall
        disallowUserChange
        returnUrl={toAbsoluteUrl(returnPath)}
        returnUrlText="Ladda om systemet"
        fullHeight
      />
    </PaywallContext.Provider>
  );
};

export default ReductionPaywall;
